/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
import React, { useCallback, useEffect, useState } from 'react';
import { PsTreeItem } from '../../../../../api/model';
import SlideToggle from '../../../../modules/SlideToggle';
import { PsDetailsMode } from '../constants/types';

export interface PsTreeNodeProps {
  /** PS 閲覧・追加・編集・比較の内、どのモードかを示す。 */
  mode: PsDetailsMode;

  /** PS ツリーの各要素。 */
  psTreeItem: PsTreeItem;

  /** 言語を表す整数。(0: 日本語, 1: 米語, 2: 英語) */
  languageId: number;

  /** 子供たちを展開する必要があるか否か。 */
  doOpenChildren: boolean;

  /** child_tree_items の各コンポーネント (PsTreeNode)。 */
  children: React.ReactNode;

  /** 階層の位置。インデント等、デザイン用に使用する。 */
  level: number;

  /** URL で指定された PS バージョン ID か、ログイン後 2 回目以降の表示の場合に前回選択されていた項目の PS バージョン ID。ログイン後、初回の表示の場合は未選択状態で undefined となる。 */
  selectedPsVersionId?: number | undefined;

  /** selectedPsVersionId が指す PsTreeItem、もしくは targetPsId と PS ID が一致する PsTreeItem。 */
  selectedPsTreeItem?: PsTreeItem | undefined;

  // /** PS ツリーの展開用。選択された psTreeItem の PS ID。 */
  // selectedPsId?: number | undefined;

  /** 改廃案などを選択状態にするために必要。PsDetails で取得した Ps。PS ツリーには承認済み最新版 PS の PsTreeItem しかなく、URL の PS バージョン ID だけでは PS ID が分からないため、必要となる。 */
  targetPsId?: number | undefined;

  /** 選択されたタイトル PS 直下のコンテンツ PSs の PsTreeItems。 */
  selectedChildContentsPsTreeItems?: PsTreeItem[] | undefined;

  // /** 選択されたタイトル PS 直下のコンテンツ PS の PS IDs。 */
  // selectedChildContentsPsIds?: number[] | undefined;

  // /** 選択されたタイトル PS 直下のコンテンツ PS のバージョン IDs。 */
  // selectedChildContentsPsVersionIds?: number[] | undefined;

  /** PS 閲覧画面で PS ツリーの項目を選択した時 (クリック時) に呼ばれる関数。 */
  setSelectedPsVersionId?: (selectedPsVersionId: number) => void | undefined;

  /** PS 閲覧画面で PS ツリーの項目を選択した時 (クリック時) に呼ばれる関数。 */
  setSelectedPsTreeItem?: (selectedPsTreeItem: PsTreeItem) => void | undefined;

  /** PS 閲覧画面で PS ツリーの項目を選択した時 (クリック時か、prop の selectedPsVersionId が psTreeItem.ps_version_id と等しい時) に呼ばれる関数。 */
  setSelectedChildContentsPsTreeItems?: (selectedChildContentsPsTreeItems: PsTreeItem[]) => void | undefined;

  // /** PS 閲覧画面で PS ツリーの項目を選択した時 (クリック時か、prop の selectedPsVersionId が psTreeItem.ps_version_id と等しい時) に呼ばれる関数。 */
  // setSelectedChildContentsPsIdVersionIds?: (selectedChildContentsPsIdVersionIds: number[][]) => void | undefined;

  // /** PS 閲覧画面で PS ツリーの項目を選択した時 (クリック時か、prop の selectedPsVersionId が psTreeItem.ps_version_id と等しい時) に呼ばれる関数。 */
  // setSelectedChildContentsPsVersionIds?: (
  //   selectedChildContentsPsVersionIds: number[]
  // ) => void | undefined;

  /** コンテキスト メニューの表示に関わる関数。 */
  setClickedTrue: () => void;
  /** コンテキスト メニューの表示に関わる関数。 */
  setPoints: (newX: number, newY: number) => void;

  /** 右クリックで選択された PsTreeItem を渡すための関数。 */
  setRightClickedPsTreeItem: (rightClickedPsTreeItem: PsTreeItem) => void;

  // /** 右クリックで選択されたこの項目の PS バージョン ID を渡すための関数。 */
  // setRightClickedPsVersionId: (rightClickedPsVersionId: number) => void;

  // /** 右クリックで選択されたこの項目の PS 種別を渡すための関数。 */
  // setRightClickedPsType: (rightClickedPsType: number) => void;

  /** PsTreeGetter から渡される関数。PostPsTreeSearchParams (/pstrees/search のパラメーター) の disp_root_ps_id に渡す値をセットする。 */
  setPsIdToFetchDescendants?: (psIdToFetchDescendants: number | undefined) => void | undefined;

  /** コンテキストメニュー表示に使用する */
  targetPsType?: number | undefined;
}

/** PsTreeItem を PS ツリーに表示するための UI。 */
function PsTreeNode({
  mode,
  // psTreeNodeData,
  // psTreeRootNodeData,
  psTreeItem,
  languageId,
  doOpenChildren,
  children,
  level,
  selectedPsVersionId,
  selectedPsTreeItem,
  targetPsId,
  // selectedPsId,
  selectedChildContentsPsTreeItems,
  // selectedChildContentsPsIds,
  // selectedChildContentsPsVersionIds,
  setSelectedPsVersionId,
  setSelectedPsTreeItem,
  // setSelectedChildContentsPsIdVersionIds,
  setSelectedChildContentsPsTreeItems,
  // setSelectedChildContentsPsVersionIds,
  setClickedTrue,
  setPoints,
  setRightClickedPsTreeItem,
  // setRightClickedPsVersionId,
  // setRightClickedPsType,
  setPsIdToFetchDescendants,
  targetPsType,
}: PsTreeNodeProps) {
  /** 子供たちを展開するか否か。 */
  const [isChildrenOpen, setIsChildrenOpen] = useState<boolean>(doOpenChildren);

  /** 比較用。描画後に doOpenChildren が変更されることがあるので、それに対応。 */
  const [previousDoOpenChildren, setPreviousDoOpenChildren] = useState<boolean>(doOpenChildren);

  /** 抜粋ステータスによりノードアイコンの色を取得 */
  const EXCERPT_STATUS_COLOR_NOTSELECT = 'Red'; // 未指定(0)
  const EXCERPT_STATUS_COLOR_NOTINCLUDE = 'Black'; // 抜粋しない(1)
  const EXCERPT_STATUS_COLOR_INCLUDE = 'deepskyblue'; // 抜粋する(2)
  const EXCERPT_STATUS_COLOR_HASNOTSELECT = '#FFCB05'; // 自身が抜粋非対象で配下に未指定あり(3) クロムイエロー (Chrome yellow)
  const EXCERPT_STATUS_COLOR_MYINCLUDE_HASNOTSELECT = '#C7A252'; // 自身が抜粋対象で配下に未指定あり(4) 蘭茶 (らんちゃ)
  const EXCERPT_STATUS_COLOR_L5TITLE = 'silver'; // L5タイトルPS
  const getExcerptStatusColor = useCallback(() => {
    // L1PSまたはL5以外のタイトルPSの場合、抜粋ステータスに対応する色を返す
    if (psTreeItem.type === 1 || (psTreeItem.type === 2 && psTreeItem.level !== 5)) {
      const id = psTreeItem.excerpt_statuses ? psTreeItem.excerpt_statuses[languageId] : 1;
      return id === 0
        ? EXCERPT_STATUS_COLOR_NOTSELECT
        : id === 1
        ? EXCERPT_STATUS_COLOR_NOTINCLUDE
        : id === 2
        ? EXCERPT_STATUS_COLOR_INCLUDE
        : id === 3
        ? EXCERPT_STATUS_COLOR_HASNOTSELECT
        : EXCERPT_STATUS_COLOR_MYINCLUDE_HASNOTSELECT;
    }
    // L5タイトルPSの場合、灰色を返す
    if (psTreeItem.type === 2 && psTreeItem.level === 5) {
      return EXCERPT_STATUS_COLOR_L5TITLE;
    }
    return EXCERPT_STATUS_COLOR_NOTINCLUDE;
  }, [psTreeItem.type, psTreeItem.level, psTreeItem.excerpt_statuses, languageId]);

  useEffect(() => {
    // 描画後に doOpenChildren が変更された場合。
    if (previousDoOpenChildren !== doOpenChildren) {
      setPreviousDoOpenChildren(doOpenChildren);

      if (doOpenChildren) {
        // 開く場合のみ対応。閉じはしない。
        setIsChildrenOpen(doOpenChildren);
      }
    }
  }, [doOpenChildren, isChildrenOpen, previousDoOpenChildren]);

  // PS 閲覧画面で PS ツリーの項目をクリックした時、および prop として親から渡された、指定された PS バージョン ID と合致していた時に呼び出す。
  // PsDetailsPage の state を設定する。
  const selectChildContentsPsTreeItems = useCallback(() => {
    // タイトル PS だった場合、直下のコンテンツ PSs の PsTreeItems を保存する。
    // そうでない場合、クリアーされる。
    if (typeof setSelectedChildContentsPsTreeItems === 'function' && mode !== 'DiffTree') {
      setSelectedChildContentsPsTreeItems(
        psTreeItem.type === 2 && Array.isArray(psTreeItem.child_tree_items)
          ? // タイトル PS の直下 (子供たち)。
            psTreeItem.child_tree_items.filter(
              // 種別がコンテンツ PS のもの。
              (childPsTreeItem: PsTreeItem) => childPsTreeItem.type === 3
            )
          : []
      );
    }
    // // タイトル PS だった場合、直下のコンテンツ PSs の PS ID と PS バージョン ID を保存する。
    // // そうでない場合、クリアーされる。
    // if (typeof setSelectedChildContentsPsIdVersionIds === 'function') {
    //   setSelectedChildContentsPsIdVersionIds(
    //     (
    //       (psTreeItem.type === 2)
    //       &&
    //       (Array.isArray(psTreeItem.child_tree_items))
    //     ) ?
    //       // タイトル PS の直下 (子供たち)。
    //       (
    //         (psTreeItem.child_tree_items).filter(
    //           // 種別がコンテンツ PS のもの。
    //           (childPsTreeItem: PsTreeItem) => (childPsTreeItem.type === 3)
    //         ).map(
    //           // PS ID と PS バージョン ID を返す。
    //           (childPsTreeItem: PsTreeItem) => [
    //             childPsTreeItem.ps_id as number,
    //             childPsTreeItem.ps_version_id as number,
    //           ]
    //         )
    //       )
    //       :
    //       []
    //   );
    // }
  }, [mode, psTreeItem.child_tree_items, psTreeItem.type, setSelectedChildContentsPsTreeItems]);

  useEffect(() => {
    // 1 クリックで 14 回呼ばれる？
    // console.log('selectChildContentsPsTreeItems');
    if (
      selectedPsVersionId === psTreeItem.ps_version_id ||
      // 改廃案など、右ペーン (PsDetails) で表示中の PS に該当する項目を PS ツリーで選択状態とする。PS ツリーには承認済み最新版の PS の PsTreeItem しかないので、この処理が必要。
      (targetPsId === psTreeItem.ps_id && !selectedPsTreeItem)
    ) {
      // prop として親から渡された、指定された PS バージョン ID と合致。
      // PsDetailsPage の states を設定する。

      if (typeof setSelectedPsTreeItem === 'function') {
        setSelectedPsTreeItem(psTreeItem);
      }

      selectChildContentsPsTreeItems();
    }
  }, [
    psTreeItem,
    selectChildContentsPsTreeItems,
    selectedPsTreeItem,
    selectedPsVersionId,
    setSelectedPsTreeItem,
    targetPsId,
  ]);

  /** 背景色。 */
  let backgroundColor = 'initial';

  /** 選択されているか否か。PS ID で判断。 */
  const isSelected =
    psTreeItem.ps_id === selectedPsTreeItem?.ps_id ||
    // (psTreeItem.ps_id === selectedPsId)
    (Array.isArray(selectedChildContentsPsTreeItems) &&
      selectedChildContentsPsTreeItems.some(
        (childContentsPsTreeItem: PsTreeItem) => childContentsPsTreeItem.ps_id === psTreeItem.ps_id
      ));

  if (mode === 'Diff' || mode === 'DiffTree' || mode === 'DiffTreeView') {
    // PS 比較画面。

    if (isSelected) {
      // 選択されている PS ツリー アイテムの背景色。
      // backgroundColor = 'Yellow';
      backgroundColor = '#FFEEDD';
    } else {
      // 選択されていない PS ツリー アイテムの背景色。

      // diff_type によって、追加された要素は黄色、移動は青色、削除は赤色でハイライトする。
      switch (psTreeItem.diff_type) {
        case 1:
          // 追加。
          backgroundColor = 'Yellow';
          break;

        case 2:
          // 移動。
          backgroundColor = 'SteelBlue';
          break;

        case 3:
          // 削除。
          backgroundColor = 'OrangeRed';
          break;

        default:
          break;
      }
    }
  } else {
    // PS 比較画面以外。

    if (isSelected) {
      // 選択されている PS ツリー アイテムの背景色。
      backgroundColor = '#FFEEDD';
    } else {
      // 選択されていない PS ツリー アイテムの背景色。

      if (psTreeItem.deleted_flag) {
        // PS 閲覧 の表示オプションで「PS 状態」の中に「廃止済み」というチェックボックスがあり、チェックすると廃止にした PS をツリーに表示することが出来る。
        // deleted_flag が 1 の時はツリー アイテムの背景色を赤色にする。
        backgroundColor = 'OrangeRed';
      } else if (psTreeItem.temp_flag) {
        // 改廃案状態の PS は、背景色 (グレー) が付く。
        backgroundColor = 'Gainsboro';
      }
    }
  }

  // モック HTML の構造が面倒だったので、構造を変えている。
  return (
    <li
      // others.css で class を設定しても、layout.css の .tree li が優先されるので、inline で style を設定する。
      style={{ margin: '5px 0' }}
    >
      <span
        style={{
          // インデント。
          marginLeft: `${0.5 * level}rem`,
          width: '1rem',
        }}
      >
        {
          // PS ツリー データは初回は L0 と L1 を全て取得し、L1 の子供展開時にその L1 の子孫を一括取得する、という仕様になった。
          // 子供を持つ場合。
          psTreeItem.child_exist_flag && (
            // caret を表示。
            <i
              // 展開・格納の状態に応じて class を変更。
              className={`fa-solid ${isChildrenOpen ? 'fa-caret-down' : 'fa-caret-right'}`}
              style={{ color: getExcerptStatusColor() }}
              onClick={() => {
                // 押下で子供たちを展開・格納。
                setIsChildrenOpen((previousIsChildrenOpen) => !previousIsChildrenOpen);

                if (!isChildrenOpen) {
                  // 格納 → 展開時。
                  if (!(Array.isArray(psTreeItem.child_tree_items) && psTreeItem.child_tree_items.length > 0)) {
                    // 子供が無い場合 (子供が無いのに caret が表示されるのは L0 か L1 のみのはず)。

                    if (typeof setPsIdToFetchDescendants === 'function') {
                      // PostPsTreeSearchParams (/pstrees/search のパラメーター) の disp_root_ps_id に渡す値をセット。
                      setPsIdToFetchDescendants(psTreeItem.ps_id);
                    }
                  }
                }
              }}
            />
          )
        }
      </span>

      <span
        // className='psTreeItemContentsSpan'
        style={{
          // 押下して反応がある場合は pointer にする。
          cursor: mode === 'View' || mode === 'DiffTreeView' ? 'pointer' : 'inherit',
          // backgroundColor,
        }}
        // 左クリックで選択。
        onClick={() => {
          if (mode === 'View' || mode === 'DiffTreeView') {
            // PS 閲覧画面の場合。

            if (!isChildrenOpen) {
              // 格納時。
              if (!(Array.isArray(psTreeItem.child_tree_items) && psTreeItem.child_tree_items.length > 0)) {
                // 子供が無い場合

                if (typeof setPsIdToFetchDescendants === 'function') {
                  // PostPsTreeSearchParams (/pstrees/search のパラメーター) の disp_root_ps_id に渡す値をセット。
                  setPsIdToFetchDescendants(psTreeItem.ps_id);
                }
              }
            }

            // コンテンツ押下で PS を選択。
            if (typeof psTreeItem.ps_version_id === 'number') {
              if (typeof setSelectedPsVersionId === 'function') {
                setSelectedPsVersionId(psTreeItem.ps_version_id);
              }
              if (typeof setSelectedPsTreeItem === 'function') {
                setSelectedPsTreeItem(psTreeItem);
              }
            }

            // 直下のコンテンツ PSs の PS ID、PS バージョン ID も設定。
            selectChildContentsPsTreeItems();
          }
        }}
        // 右クリックでコンテキスト メニュー表示。
        // 参照: https://blog.logrocket.com/creating-react-context-menu/
        onContextMenu={(event: React.MouseEvent) => {
          if (
            mode === 'View' ||
            ((mode === 'Edit' || mode==='Add') &&
              Number(psTreeItem.level) > 2 &&
              Number(psTreeItem.type) < 3 &&
              Number(targetPsType) === 3)
          ) {
            /**
             * 以下の場合、コンテキストメニューを表示する
             * PS 閲覧画面の場合
             * コンテンツPSが編集モードで、ツリー上で章PS,タイトルPSを右クリックした場合
             *
             * ※メニューの内容はPsTree側で制御
             */

            // prevent the default behaviour (ブラウザーのデフォルトのコンテキスト メニュー) when right clicked.
            event.preventDefault();

            // コンテキスト メニューを表示するために PsTree の state を変更。
            setClickedTrue();
            setPoints(event.pageX, event.pageY);

            // コンテキスト メニュー → PS 新規作成ダイアログ・PS 差分指定ダイアログのために PsTreeItem を渡す。
            setRightClickedPsTreeItem(psTreeItem);

            // // コンテキスト メニュー → PS 新規作成ダイアログ・PS 差分指定ダイアログのために PS バージョン ID を渡す。
            // if (typeof psTreeItem.ps_version_id === 'number') {
            //   setRightClickedPsVersionId(psTreeItem.ps_version_id);
            // }
            // // コンテキスト メニュー → PS 新規作成ダイアログのために PS 種別を渡す。
            // if (typeof psTreeItem.type === 'number') {
            //   setRightClickedPsType(psTreeItem.type);
            // }

            // console.log("Right Click: ", event.pageX, event.pageY);
          }
        }}
      >
        {psTreeItem.type !== 3 && level !== 0 && (
          <span
            className="mkn"
            // style={{
            //   width: '1rem',
            //   color: '#c21413',
            //   fontWeight: 'bold',
            //   marginLeft: '0.25rem',
            // }}
          >
            {psTreeItem.level}
          </span>
        )}

        <span>
          {getIconImageFilePaths(psTreeItem).map((iconImageFilePath: string) => (
            <img key={iconImageFilePath} alt="icon" style={{ width: '1rem' }} src={iconImageFilePath} />
          ))}
        </span>

        {/* テキスト。 */}
        <span
          style={{
            // search_result が true の時は通常の文字色、false の時はグレーの文字色で表示する。
            color: psTreeItem.search_result ? '#333333' : 'LightGray',
            backgroundColor,
          }}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: psTreeItem.titles ? psTreeItem.titles[languageId] : '' }}
        />
        {/* {
            (psTreeItem.titles)
            &&
            (psTreeItem.titles[languageId])
          }
        </span> */}
      </span>

      {
        // 子供たちがあれば、展開・格納できるようにする。
        Array.isArray(psTreeItem.child_tree_items) && psTreeItem.child_tree_items.length > 0 && (
          <SlideToggle open={isChildrenOpen}>
            <ul
              // className={`treeul${((psTreeItem.level) ?? 1) + 1}`}
              style={{
                backgroundColor: '#FFFFFF',
              }}
            >
              {children}
            </ul>
          </SlideToggle>
        )
      }
    </li>
    // </Draggable>
  );
}
// );

PsTreeNode.defaultProps = {
  selectedPsVersionId: undefined,
  selectedPsTreeItem: undefined,
  selectedChildContentsPsTreeItems: undefined,
  targetPsId: undefined,
  setSelectedPsVersionId: undefined,
  setSelectedPsTreeItem: undefined,
  setSelectedChildContentsPsTreeItems: undefined,
  setPsIdToFetchDescendants: undefined,
  targetPsType: undefined,
};

export default PsTreeNode;

export const getIconImageFilePaths = (psTreeItem: PsTreeItem) => {
  // 表示するアイコンのパスの配列。
  const iconImageFilePaths = [];

  if (psTreeItem.illust_exist) {
    // イラストがあればイラスト アイコンを表示。
    iconImageFilePaths.push('/images_ps/illust.svg');
  }
  if (psTreeItem.table_exist) {
    // 表があれば表アイコンを表示。
    iconImageFilePaths.push('/images_ps/table.svg');
  }
  // 記載条件分類に応じて表示するアイコンを変える。
  switch (psTreeItem.text_type) {
    case 1:
      // 注意。
      iconImageFilePaths.push('/images_ps/caution.svg');
      break;

    case 2:
      // 警告。
      iconImageFilePaths.push('/images_ps/warning.svg');
      break;

    case 3:
      // 危険。
      iconImageFilePaths.push('/images_ps/danger.svg');
      break;

    case 4:
      // アドバイス。
      iconImageFilePaths.push('/images_ps/notice.svg');
      break;

    default:
      break;
  }

  return iconImageFilePaths;
};
